import { Icon, IconProps } from '@chakra-ui/react'

export default function HomeIcon(props: IconProps) {
  return (
    <Icon
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={'#2196F3'}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.83333 8.6665H8.16667C9.17919 8.6665 10 9.48732 10 10.4998V13.9998H6V10.4998C6 9.48732 6.82081 8.6665 7.83333 8.6665Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 12V7.30648C2 6.39513 2.41426 5.5332 3.1259 4.96388L5.91767 2.73045C7.13507 1.75652 8.86493 1.75652 10.0823 2.73045L12.8741 4.96387C13.5857 5.53319 14 6.39512 14 7.30647V12C14 13.1046 13.1046 14 12 14H4C2.89543 14 2 13.1046 2 12Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}
